import { practitionerIsActive, getIsPactitionerActive } from "@services/signup";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@redux/store";

const usePractitionerIsActive = (username?: string) => {
    const [ isActive, setIsActive ] = useState<boolean | null>(null);
    const [ user, setUser ] = useState<string | null>(null);
    const [ isLoading, setIsLoading ] = useState<boolean>(false);

    const { username: sessionUsername } = useSelector((state: RootState) => state.session);

    useEffect(() => {
        setUser(username || sessionUsername || null);
    }, [sessionUsername, username]);

    const loadData = useCallback(async() => {
        if(!user) return;
        setIsLoading(true);
        const promises = [
            practitionerIsActive(user),
            getIsPactitionerActive()
        ];

        const results = await Promise.allSettled(promises);
        const statusList = results
            .filter(resp => resp.status === "fulfilled")
            .map(resp => resp.status === "fulfilled" ? resp.value : undefined) as boolean[];

        const status = statusList.some(st => st === true);
        setIsActive(status);
    }, [user]);

    useEffect(() => {
        loadData();
    }, [loadData]);

    return { isActive, isLoading };
};

export default usePractitionerIsActive;
